import React from 'react';
import '../styles/search.css';
import { RxCross2 } from 'react-icons/rx';


const Search = ({icon, id, type, onSearchClick, iconId, onKeyDown, toggleDatePicker, placeholder, clearFilter, setInitialState }) => {
  return (
    <div className='search_box'>
        <input type={type} name={type} placeholder={id==='date_picker' ? placeholder : 'Search'} className='search' id={id} onKeyDown={onKeyDown} readOnly={id==='date_picker' && true }  />
        <span className='search_icon' id={iconId} onClick={id==='date_picker' ? toggleDatePicker : onSearchClick}>
          {icon}
        </span>
        {clearFilter && <RxCross2 style={{ fontSize: '30px', marginLeft: '5px', cursor: 'pointer'}} onClick={setInitialState} />}
    </div>
  )
}

export default Search;